import Vue from "vue";
import Router from "vue-router";
import AppLayout from "../components/admin/AppLayout";
import createOrder from "../components/PaymentOrder/createOrderByMerchants";
import downloadDoc from "../components/PaymentOrder/downloadAttachment";
import page404 from "../components/pages/404-pages/PageNotFound";
import Blank from "../blank";
import lazyLoading from "./lazyLoading";
import pageName from '../components/NewUser/pageNames';

Vue.use(Router);

const EmptyParentComponent = {
  template: "<router-view></router-view>"
};

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: {
        name: "login"
      },
      component: () => import("../components/auth/AuthLayout")
    },
    {
      path: "/login",
      redirect: {
        name: "login"
      },
      component: () => import("../components/auth/AuthLayout")
    },
    {
      path: "/resetPassword",
      redirect: {
        name: "resetPassword"
      },
      component: () => import("../components/auth/AuthLayout")
    },
    {
      path: "/blank",
      component: Blank
    },
    {
      path: "/createOrder",
      name: "createOrder",
      component: createOrder
    },
    {
      path: "/downloadDoc",
      name: "downloadDoc",
      component: downloadDoc
    },
    {
      path: "/auth",
      component: () => import(`${process.env.VUE_APP_WEBSETE_SIGN === 'ps' ? "../components/auth/AuthLayout" : "../components/auth/LtAuthLayout"}`),
      children: [
        {
          name: "login",
          path: "login",
          component: lazyLoading("auth/login/Login")
        },
        {
          name: "resetPassword",
          path: "resetPassword",
          component: lazyLoading("auth/resetPassword/Index")
        }
      ]
    },
    // {
    //   path: "/auth",
    //   component: () => import("../components/auth/LtAuthLayout"),
    //   children: [
    //     // {
    //     //   name: "login-testing",
    //     //   path: "login-testing",
    //     //   component: lazyLoading("auth/login/LtLogin")
    //     // },
    //     {
    //       name: "signup",
    //       path: "signup",
    //       component: lazyLoading("auth/signup/Signup")
    //     }
    //   ]
    // },
    {
      path: "/forward",
      name: "redirectPage",
      component: lazyLoading("pages/jump_page/redirectPage")
    },
    {
      path: "/sys_error",
      name: "systemError",
      component: lazyLoading("pages/error-pages/systemError")
    },
    {
      path: "/defend_page",
      name: "safeguard-page",
      component: lazyLoading("pages/error-pages/safeguard")
    },
    {
      path: "/404",
      name: "404",
      component: page404
    },
    {
      path: "/plugin/auth-bind",
      name: "Shoplazza",
      meta: {
        needLogin: true,
        // 独立外部插件页：只校验登录态，不走系统权限；未登录回跳仅对本路由生效
        externalPlugin: true,
      },
      component: lazyLoading("External/Shoplazza/index"),
    },
    {
      path: "/",
      component: AppLayout,
      children: [
        {
          name: "Dashboard",
          path: "dashboard",
          meta: {
            needLogin: true,
          },
          redirect: {
            name: "PaymentOrder"
          },
          // component: lazyLoading("dashboard/Dashboard"),
          // default: true
        },
        {
          name: "PaymentOrder",
          path: "order",
          meta: {
            needLogin: true,
            // permName: pageName.transactions
          },
          component: lazyLoading("PaymentOrder/PaymentOrder"),
          default: true
        },
        {
          name: "PayOrderDetails",
          path: "order/details",
          meta: {
            needLogin: true,
            // permName: pageName.transactions
          },
          component: lazyLoading("PaymentOrder/PayOrderDetails"),
          default: true
        },
        {
          name: "PaymentOrderDownload",
          path: "PaymentOrderDownload",
          meta: {
            needLogin: true,
            // permName: pageName.transactions
          },
          component: lazyLoading("PaymentOrder/PaymentOrderDownload"),
          default: true
        },
        {
          name: "Recurring",
          path: "Recurring",
          meta: {
            needLogin: true,
          },
          component: lazyLoading("Recurrings/RecurringsList"),
          default: true
        },
        {
          name: "VirtualAccount",
          path: "VirtualAccount",
          meta: {
            needLogin: true,
          },
          component: lazyLoading("VirtualAccount/VirtualAccountList"),
          default: true
        },
        {
          name: "VirtualAccountDetail",
          path: "VirtualAccountDetail",
          meta: {
            needLogin: true,
          },
          component: lazyLoading("VirtualAccount/VirtualAccountDetail"),
          default: true
        },
        {
          name: "RecurringsDetail",
          path: "RecurringsDetail",
          meta: {
            needLogin: true,
          },
          component: lazyLoading("Recurrings/RecurringsDetail"),
          default: true
        },
        {
          name: "RecurringDownload",
          path: "RecurringDownload",
          meta: {
            needLogin: true,
          },
          component: lazyLoading("Recurrings/RecurringDownload"),
          default: true
        },
        {
          name: "Report",
          path: "report",
          meta: {
            needLogin: true,
            permName: pageName.report
          },
          component: lazyLoading("Report/Report"),
          default: true
        },
        {
          name: "AdvanceDownload",
          path: "report/advanceDownload",
          meta: {
            needLogin: true,
            permName: pageName.report
          },
          component: lazyLoading("Report/AdvanceDownload"),
          default: true
        },
        {
          name: "UserManagement",
          path: "user",
          meta: {
            needLogin: true,
            permName: pageName.userManagement
          },
          component: lazyLoading("UserManagement/UserManagement"),
          default: true
        },
        // settlement
        /* {
          name: 'Settlement',
          path: 'Deal',
          meta: {
            needLogin: true
          },
          component: lazyLoading('Settlement/Settlement'),
          default: true,
        },
        {
          name: 'NewSettlement',
          path: 'Deal/CreateADeal',
          meta: {
            needLogin: true
          },
          component: lazyLoading('Settlement/ApplyA_Settlement'),
          default: true,
        }, */
        {
          name: "FinancialManagementHome",
          path: "financialHome",
          meta: {
            needLogin: true,
            permName: pageName.finance
          },
          // component: lazyLoading("FinancialManagement/FinancialManagement"),
          default: true
        },
        {
          name: "FinancialManagement",
          path: "financial",
          meta: {
            needLogin: true,
            permName: pageName.finance
          },
          component: lazyLoading("FinancialManagement/Index"),
          default: true
        },
        {
          name: "BankAccounts",
          path: "bank-accounts",
          meta: {
            needLogin: true,
            permName: pageName.finance
          },
          component: lazyLoading("FinancialManagementNew/BankAccounts"),
          default: true
        },
        {
          name: "AppManagement",
          path: "app",
          meta: {
            needLogin: true,
            permName: pageName.appManagement
          },
          component: lazyLoading("AppManagement/AppManagement"),
          default: true
        },
        {
          name: "EditAppInfo",
          path: "app/edit/:app_id",
          meta: {
            needLogin: true,
            permName: pageName.appManagement
          },
          component: lazyLoading("AppInfo/EditAppInfo"),
          default: true
        },
        {
          name: "ViewAppInfo",
          path: "app/view/:app_id",
          meta: {
            needLogin: true,
            permName: pageName.appManagement
          },
          component: lazyLoading("AppInfo/EditAppInfo"),
          default: true
        },
        {
          name: "MerchantKYC",
          path: "kyc",
          meta: {
            needLogin: true,
            permName: pageName.merchantKyc
          },
          component: lazyLoading("MerchantKYC/MerchantKYC"),
          default: true
        },
        {
          name: "NewUser",
          path: "user/new",
          meta: {
            needLogin: true,
            permName: pageName.userManagement
          },
          component: lazyLoading("NewUser/NewUser"),
          default: true
        },
        {
          name: "EditUser",
          path: "user/edit",
          meta: {
            needLogin: true,
            permName: pageName.userManagement
          },
          component: lazyLoading("NewUser/EditUser"),
          default: true
        },
        {
          name: "NewApp",
          path: "app/new",
          meta: {
            needLogin: true,
            permName: pageName.appManagement
          },
          component: lazyLoading("NewApp/NewApp"),
          default: true
        },
        {
          name: "Profile",
          path: "profile",
          meta: {
            needLogin: true
          },
          component: lazyLoading("Profile/Profile"),
          default: true
        },
        {
          name: "WayBillList",
          path: "wayBill",
          meta: {
            needLogin: true,
            permName: pageName.wayBill
          },
          component: lazyLoading("WayBill/WayBillList"),
          default: true
        },
        {
          name: "WayBillDetail",
          path: "wayBill/detail",
          meta: {
            needLogin: true,
            permName: pageName.wayBill
          },
          component: lazyLoading("WayBill/PaymentOrderDetail"),
          default: true
        },
        {
          name: "BatchUpload",
          path: "upload",
          meta: {
            needLogin: true,
            permName: pageName.wayBill
          },
          component: lazyLoading("WayBill/BatchUpload"),
          default: true
        },
        {
          name: "DownloadLog",
          path: "downloadLog",
          meta: {
            needLogin: true,
            permName: pageName.wayBill
          },
          component: lazyLoading("WayBill/DownloadLog"),
          default: true
        },
      ]
    }
  ]
});
